module.exports = __webpack_public_path__ + "img/hemisphericalIcon.5b800d69.png";